import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHtmlContent, setHtmlContentSH } from "../../features/redux/statusFileSlice";
import {
  fetchOrderFile,
  fetchOrderSHFile,
} from "../../features/action/fetchStatusFile";
import {  clientPay, comment, commentTrue, img, imgFalse, sh, shFalse, so, soFalse } from "../../util/icon";
import { ShowOrder } from "../common/ShowOrder";
import { ShowImgStatus } from "../common/ShowImgStatus";
import { getImageStatusFileFetch } from "../../features/action/fetchImage";
import {
  putStatusComment,
  putUpdateStatusAll,
  changeDataFetch,
} from "../../features/action/fetchStatus";
import {
  DateBLock,
  getClientInfo,
  imgStudio,
  MembersBlock,
  place,
  renderStatusImage,
  iconStatus,
  getStudioStatusKey,
} from "../../util/main";
import { ShowComment } from "../common/ShowComment";
import { ShowOrderSH } from "../common/ShowOrderSH";

export const Disigner = ({ i, isName }) => {
  const { imgStatus } = useSelector((state) => state.imageFile);
  const [isFlipped, setIsFlipped] = useState(false);
  const [isFlipped2, setIsFlipped2] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [showOrderSH, setShowOrderSH] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [showClientInfo, setShowClientInfo] = useState(false);

  const dispatch = useDispatch();

  const handleClickStatus = (nameStatus, id) => {
    dispatch(putUpdateStatusAll(id, nameStatus));
  };

  const handleOpenText = (e) => {
    e.stopPropagation();
    setIsFlipped(!isFlipped);
  };

  const handleOpenOrder = (e, numOrder) => {
    e.stopPropagation();
    dispatch(setHtmlContent(null));
    dispatch(fetchOrderFile(numOrder));
    setShowOrder(true);
  };

  const handleOpenOrderSH = (e, tableSH) => {
      e.stopPropagation();
      dispatch(setHtmlContentSH(null));
      dispatch(fetchOrderSHFile(tableSH));
      setShowOrderSH(true);
    };

  const handleOpenImage = (e, url) => {
    e.stopPropagation();
    dispatch(getImageStatusFileFetch(url));
    imgStatus && setShowItems(true);
  };

  const handleOpenComment = (e) => {
    e.stopPropagation();
    setShowComment(true);
  };

  const handlePushComment = (e, comment) => {
    
    e.stopPropagation();
    dispatch(putStatusComment(i._id,comment,isName.username))
    setShowComment(false);
  };

  const handleDateChange = (newDate, newTime, statusId) => {
    dispatch(changeDataFetch(statusId, { toDate: newDate, toTime: newTime }));
  };

  const { name: clientName, phone: clientPhone } = getClientInfo(i.client);

  return (
    <>
      <div className="relative flex w-[33%] overflow-hidden">
        <DateBLock 
          toDate={i.toDate} 
          fromDate={i.fromDate}
          toTime={i.toTime}
          widthClass="w-[48.48%]"
          onDateChange={handleDateChange}
          statusId={i._id}
        />
        {MembersBlock(i.manager, i.designer, i.sewing, "w-[51.52%]")}
        {/* Выезжающая панель с информацией о клиенте */}
        <div
          className={`absolute inset-0 bg-[#ffffff] flex items-center justify-center transition-transform duration-500 ease-in-out z-10  rounded-l-[8px] ${
            showClientInfo ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="text-black font-rubik text-sm text-center px-2">
            <p className="font-bold leading-tight mb-1">{clientName}</p>
            <p className="text-xs leading-tight">{clientPhone}</p>
          </div>
        </div>
      </div>
      <div className="flex flex-row w-[28%] h-[60px] content-center">
        <div
          className="content-center cursor-pointer"
          onClick={() => setShowClientInfo(!showClientInfo)}
        >
          {clientPay}
        </div>

        <div className={"w-[68%]  content-center"}>
          <div
            className="relative w-full h-full cursor-pointer"
            onClick={handleOpenText}
            style={{ perspective: "1000px" }}
          >
            <div
              className="relative w-full h-full transition-transform duration-500"
              style={{
                transformStyle: "preserve-3d",
                transform: isFlipped ? "rotateX(180deg)" : "rotateX(0deg)",
              }}
            >
              {/* Передняя сторона - номер заказа */}
              <div
                className={`absolute w-full h-full flex items-center justify-center bg-[#739D00]`}
                style={{ backfaceVisibility: "hidden" }}
              >
                <div className="flex flex-row justify-center items-center ">
                  <p className="font-rubik font-medium text-[clamp(10px,1.2vw,16px)] leading-tight tracking-wide-5 text-[#D2E3A4] px-1">
                    {i.order.slice(0, 6)}
                  </p>
                  <p className="font-rubik font-black text-[clamp(20px,3vw,40px)] leading-tight tracking-wide-5 text-[#FFFFFF] px-1">
                    {i.order.slice(6)}
                  </p>
                </div>
              </div>
              {/* Задняя сторона - текст клиента */}
              <div
                className={`absolute w-[100%] h-full flex bg-[#739D00] text-left items-center justify-center `}
                style={{
                  backfaceVisibility: "hidden",
                  transform: "rotateX(180deg)",
                }}
              >
                <div className="flex w-full h-full justify-evenly content-center items-center">
                  {/* ---------------------------------------Show HTML SO-------------------------------------------------- */}
                  <button
                    className="text-[2vw] w-[11%] content-center "
                    onClick={
                      i.order ? (e) => handleOpenOrder(e, i.order) : null
                    }
                  >
                    {i.order ? so : soFalse}
                  </button>
                  {/* ---------------------------------------Show HTML SH-------------------------------------------------- */}
                  {
                    <button
                      className="text-[2vw] w-[11%] content-center "
                      onClick={
                        i.tableSH
                          ? (e) => handleOpenOrderSH(e, i.tableSH.orderSH)
                          : null
                      }
                    >
                      {i.tableSH ? sh : shFalse}
                    </button>
                  }
                  {/* ---------------------------------------Image-------------------------------------------------- */}
                  {
                    <button
                      className="text-[2vw]  w-[11%] content-center "
                      onClick={i.img ? (e) => handleOpenImage(e, i.img) : null}
                    >
                      {i.img ? img : imgFalse}
                    </button>
                  }
                  {/* ---------------------------------------Comment-------------------------------------------------- */}
                  <button className="text-[2vw]  w-[11%] content-center  ">
                    {/* { i.comment ? comment : commentTrue } */}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          className={`flex w-[18%] ${i.comment?.length > 0 ? "bg-[#739D00]" : "bg-[#739D00] opacity-50"} items-center justify-center`}
          onClick={(e) => handleOpenComment(e)}
        >
          {i.comment?.length > 0 ? comment : commentTrue}
        </button>

        {showOrder && <ShowOrder setShowOrder={setShowOrder} />}
        {showOrderSH && <ShowOrderSH setShowOrderSH={setShowOrderSH} />}
        
        {showItems && (
          <ShowImgStatus
            url={imgStatus}
            setShowItems={setShowItems}
            loadingImage={imgStatus}
          />
        )}
        {showComment && (
          <ShowComment
            setShowComment={setShowComment}
            statusComment={i.comment}
            order={i.order}
            handlePushComment={handlePushComment}
          />
        )}
      </div>

      <div
        className="flex w-[29%] items-center"
        style={{ perspective: "1000px" }}
      >
        <div
          className="relative w-full h-full transition-transform duration-500"
          style={{
            transformStyle: "preserve-3d",
            transform: isFlipped2 ? "rotateX(180deg)" : "rotateX(0deg)",
          }}
        >
          {/* Передняя сторона */}
          <div
            className="absolute w-full h-full flex items-center"
            style={{ backfaceVisibility: "hidden" }}
          >
            <div className="flex w-[80%] items-center">
              <div className="px-5"> {place(i.numberLine)}</div>
              <span className="text-[#979797] font-rubik font-bold text-xl leading-[100%] tracking-[0.05em] text-center align-middle">
                {i.numberPlace}
              </span>
            </div>
            <div
              className="w-[20%] flex items-center justify-center cursor-pointer"
              onClick={() => setIsFlipped2(true)}
            >
              {imgStudio(i.studio)}
            </div>
          </div>
          {/* Задняя сторона */}
          <div
            className="absolute w-full h-full flex items-center"
            style={{
              backfaceVisibility: "hidden",
              transform: "rotateX(180deg)",
            }}
          >
            <div
              className="flex w-[100%] items-center justify-center"
              onClick={() => setIsFlipped2(false)}
            >
              <div className="flex w-[80%] items-center justify-evenly">
                {iconStatus
                  .filter((status) => status !== getStudioStatusKey(i.studio))
                  .map((status) => (
                    <div
                      key={status}
                      className="cursor-pointer"
                      onClick={() => handleClickStatus(status, i.studio._id)}
                    >
                      {renderStatusImage(status)}
                    </div>
                  ))}
              </div>
              <div
                className="w-[20%] flex items-center justify-center cursor-pointer"
                onClick={() => setIsFlipped2(true)}
              >
                {imgStudio(i.studio)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
